import { render, staticRenderFns } from "./AnagraficaTable.vue?vue&type=template&id=020115b8&"
import script from "./AnagraficaTable.vue?vue&type=script&lang=ts&"
export * from "./AnagraficaTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports